import kanye from "../../img/fem.png";
import { ProjektContent } from "../News";
import styled from "styled-components";

const Balls = styled.div`
  width: 90%;
  height: 90%;
  background-image: url(${(props) => props.broke || kanye});
  border: 2px lightgray solid;
  transition: 300ms;
  background-size: 140% 140%;
  cursor: pointer;
  &:hover {
    width: 85%;
    height: 85%;
  }
`;
const WTF = styled.div`
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transition: 300ms;

  & > p {
    font-size: 1.5rem;
    color: #fff;
    opacity: 0;
    transition: 300ms;
    font-weight: bold;
    text-decoration: underline;
    &:hover {
      color: blue;
    }
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.65);
    & > p {
      opacity: 1;
    }
  }
`;
export default function Web() {
  return (
    <ProjektContent>
      <Balls broke={kanye}>
        <WTF>
          <p>Sprawdź moje prace na Front End Mentor</p>
        </WTF>
      </Balls>
    </ProjektContent>
  );
}
